import { makeObservable, observable, action, runInAction } from 'mobx';
import { authHandler } from '../handlers/authHandler';
import { jwtDecode } from 'jwt-decode';
import SnackbarStore from './SnackbarStore';
import { severity } from '../utils/severity';
import LoadingProgressStore from './LoadingProgressStore';

class AuthStore {
  isAuthenticated = false;
  sessionExpirayIdelTimer = 0;
  userDetails = null;

  constructor() {
    makeObservable(this, {
      isAuthenticated: observable,
      login: action,
      logout: action,
    });

    this.toggleIsUserAuthnticated();
  }

  async login(userName, password) {
    authHandler
      .login(userName, password)
      .then((response) => {
        if (!response.data?.[0]?.token) {
          SnackbarStore.toggleSnackbar(true, severity.error, 'Invalid Username/Password');
        } else {
          this.#updateAuthDetails(response.data[0]);
        }
      })
      .catch((err) => {
        SnackbarStore.toggleSnackbar(true, severity.error, err.message);
        console.error(err);
      })
      .finally(() => {
        LoadingProgressStore.toggleIsLoading(false);
      });
  }

  refreshToken = () => {
    authHandler
      .refreshToken()
      .then((response) => {
        this.#updateAuthDetails(response.data);
      })
      .catch((err) => {
        SnackbarStore.toggleSnackbar(true, severity.error, err.message);
        console.error(err);
      });
  };

  async forgotPassword(userName) {
    authHandler
      .forgotPassword(userName)
      .then((response) => {
        SnackbarStore.toggleSnackbar(true, severity.success, 'Successfully sent notification');
      })
      .catch((err) => {
        SnackbarStore.toggleSnackbar(true, severity.error, err.message);
        console.error(err);
      })
      .finally(() => {
        LoadingProgressStore.toggleIsLoading(false);
      });
  }

  #updateAuthDetails = (data) => {
    localStorage.setItem('authentication', JSON.stringify(data));
    runInAction(() => {
      this.isAuthenticated = true;
      this.tokenExpiry = data.tokenExpiry;
      this.userDetails = JSON.parse(jwtDecode(data.token)?.JwtDto);
      setTimeout(
        () => {
          this.refreshToken();
        },
        (this.tokenExpiry - 1) * 60000
      );
    });
  };

  logout() {
    // Perform logout logic here, set isAuthenticated to false
    this.isAuthenticated = false;
    this.clearToken();
  }

  toggleIsUserAuthnticated = () => {
    const authDetails = localStorage.getItem('authentication');
    if (authDetails) {
      this.isAuthenticated = true;
      this.userDetails = JSON.parse(jwtDecode(JSON.parse(authDetails).token)?.JwtDto);
    } else {
      this.isAuthenticated = false;
    }
  };

  setSessionExpirayIdelTimer = (sessionExpirayIdelTime) => {
    this.sessionExpirayIdelTimer = sessionExpirayIdelTime;
  };

  clearToken = () => {
    localStorage.removeItem('authentication');
  };
}

export default new AuthStore();
// export const AuthStoreContext = createContext(new AuthStore());
